import React from 'react';
import PropTypes from 'prop-types';
import ReactFitText from 'react-fittext';
import styles from './section-message.module.css';

const SectionMessage = ({ message, secondary }) => {
  return (
    <div className={styles.wrapper}>
      <ReactFitText compressor={3.35} minFontSize={16} maxFontSize={20}>
        <p
          className={styles.copy}
          dangerouslySetInnerHTML={{ __html: message }}
        />
      </ReactFitText>
      {typeof secondary !== 'undefined' ? (
        <ReactFitText compressor={3.35} minFontSize={16} maxFontSize={20}>
          <p
            style={{ marginTop: '1rem' }}
            className={styles.copy}
            dangerouslySetInnerHTML={{ __html: secondary }}
          />
        </ReactFitText>
      ) : null}
    </div>
  );
};

SectionMessage.propTypes = {
  message: PropTypes.string,
  secondary: PropTypes.string,
};

export default SectionMessage;



// WEBPACK FOOTER //
// ./src/components/section-message/index.js